import * as Yup from 'yup';

export const companyValidationSchema = Yup.object({
  name: Yup.string().required("Nombre es requerido"),
  logo: Yup.mixed().test({name: "LogoFile", test: (value, ctx) => {
    // admitimos que no se agregue logo
    if (value === undefined || value === null) return true;
    // validamos si es un string en caso de edición
    if (typeof value === "string") return true;
    if (!(value instanceof File)) return false;
    // archivo debe ser menor a 5MB
    if (value.size > 5000000) return ctx.createError({message: "El archivo debe ser menor a 5MB"});
    return true;
  }}),
  dominio: Yup.string().required("Dominio es requerido."),
  extension: Yup.string().matches(/^(\w{2,}|\.\w{2,}|\.\w{2,}\.\w{2,})$/, "Extensión no es válida. Ejemplos: 'com', 'com.ar', 'ar', etc.").required("Extensión es requerido"),
  debqUrl: Yup.string().matches(/^(https?:\/\/)?([\w-]+\.)*[\w-]+(:\d{1,5})?(\/[^/].*)?$/, "La URL no es válida. Debe comenzar con 'http://', 'https://' o 'www'. No debe incluir '/' al final.").required("URL del debQ es requerido"),
  debqUser: Yup.string().required("Usuario del debQ es requerido"),
  debqPassword: Yup.string().required("Contraseña del debQ es requerido"),
  debqToken: Yup.string(),
});
